<div class='cosmos-table__wrapper'>
  <ng-container *ngIf="isFilterable">
    <div class="cosmos-table__controls">
      <div class="cosmos-table__controls__filters">
        <cosmos-searchbar 
          [hidden]="!hasSearchbar" 
          [placeholderContent]="_searchbarPlaceholder"
        ></cosmos-searchbar>
        <cosmos-filter [hidden]="!hasDropdownFilter"></cosmos-filter>
        <cosmos-checkbox-filter [hidden]="!hasCheckboxFilter"></cosmos-checkbox-filter>
      </div>
      <div class="cosmos-table__controls__panel">
        <ng-container [ngTemplateOutlet]="controlPanelTemplate"></ng-container>
      </div>
    </div>
  </ng-container>
  <div class="cosmos-table__container">
    <div class="cosmos-table__container__spacer">
      <div class="cosmos-table__container__spacer__top"></div>
      <div class="cosmos-table__container__spacer__bottom"></div>
    </div>
    <div class="cosmos-table">
      <div 
        *ngIf="isDownloading" 
        class="cosmos-table__downloading-screen"
      >
        Preparing requested file for download...
      </div>
      <table
        [id]="tableId"
        [dataSource]="_dataSource"
        mat-table
        matSort
      >
        <ng-container
          *ngFor="let column of _columns"
          [matColumnDef]="column.columnId"
        >
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            [disabled]="!column.sortable"
            class="cosmos-table__header"
          >
            <ng-container *ngIf="!column.headerTemplate">
              {{ column.caption }}
            </ng-container>
            <ng-container
              *ngIf="column.headerTemplate"
              [ngTemplateOutlet]="column.headerTemplate"
            ></ng-container>
          </th>
          <td
            *matCellDef="let row"
            mat-cell
          >
            <div
              [ngSwitch]="column.type"
              [ngClass]="{
                'cosmos-table__cell': true,
                'cosmos-table__cell__centered': column.alignment === ColumnAlignment.Centered,
                'cosmos-table__cell__right': column.alignment === ColumnAlignment.Right,
                'cosmos-table__cell__left': column.alignment === ColumnAlignment.Left
              }"
            >
              <div *ngSwitchCase="ColumnType.Date">
                {{column.fieldSelector(row) | date:'yyyy-MM-dd'}}
              </div>
              <div
                *ngSwitchCase="ColumnType.Image"
                class="cosmos-table__cell__image__container"
              >
                <ng-container *ngIf="column.fieldSelector(row); else hasNoCover">
                  <img
                    src={{column.fieldSelector(row)}}
                    class="cosmos-table__cell__image"
                  >
                </ng-container>
                <ng-template #hasNoCover>
                  <span>No cover selected</span>
                </ng-template>
              </div>
              <div
                *ngSwitchCase="ColumnType.Template"
                [ngClass]="{'cosmos-table__cell__preview__container': column.columnId === 'preview'}"
              >
                <ng-container
                  *ngIf="!!column.template"
                  [ngTemplateOutlet]="column.template"
                  [ngTemplateOutletContext]="{ $implicit: column.fieldSelector(row), row: row, column: column }"
                  class="cosmos-table__cell__preview"
                ></ng-container>
              </div>
              <div *ngSwitchCase="ColumnType.Status">
                <div [ngClass]="{
                  'cosmos-table__cell__status__accepted': column.fieldSelector(row) === InviteStatus.Accepted,
                  'cosmos-table__cell__status__pending': column.fieldSelector(row) === InviteStatus.Pending,
                  'cosmos-table__cell__status__not-invited': column.fieldSelector(row) === InviteStatus.NotInvited
                }">
                  {{column.fieldSelector(row)}}
                </div>
              </div>
              <div *ngSwitchDefault>
                {{column.fieldSelector(row)}}
              </div>
            </div>
          </td>
        </ng-container>
        <tr
          *matHeaderRowDef="_displayedColumns"
          mat-header-row
          class="cosmos-table__header"
        >
        </tr>
        <tr
          *matRowDef="let row; columns: _displayedColumns"
          mat-row
          (click)="onTableRowClick(row)"
          class="cosmos-table__row"
        ></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No Data</td>
        </tr>
      </table>
    </div>
    <div class="cosmos-table__container__spacer">
      <div class="cosmos-table__container__spacer__top"></div>
      <div class="cosmos-table__container__spacer__bottom"></div>
    </div>
  </div>
  <div
    *ngIf="optionalSummaryTemplate"
    class="cosmos-table__summary"
  >
    <ng-container [ngTemplateOutlet]="optionalSummaryTemplate"></ng-container>
  </div>
  <div
    *ngIf="isPaginable"
    [ngClass]="paginatorType === 'default' ? 'cosmos-table__pagination' : 'cosmos-table__pagination-compact'"
  >
    <cosmos-paginator [paginatorType]="paginatorType"></cosmos-paginator>
  </div>
</div>
